import React, { FC } from "react";
import { useParams } from "react-router-dom";

import { SupplierForm } from "@components/main/procurement";
import { NotAuthorized } from "@components/common";

const SupplierFormPage: FC = () => {
  const { procurementId } = useParams<{ procurementId: string }>();

  if (!procurementId) {
    return <NotAuthorized />;
  }

  return <SupplierForm />;
};

export default SupplierFormPage;
